<mat-toolbar>
    <span>Envío a AB</span>
    <span class="spacer"></span>
</mat-toolbar>
<div class="p-5 bg-white w-full">
    <div class="flex pl-5 pr-5">
        <table class="tblEnvioAB">
            @for (item of listaFormaEnvio; track $index) {
                <tr>
                    <td>{{item.tipo_descripcion.toUpperCase()}}</td>
                    <td>{{item.enviado_descripcion.split(" | ")[0].toUpperCase()}}</td>
                    <td class="min-width">{{item.fecha}}</td>
                    <td class="min-width">{{item.leido_fecha}}</td>
                    <td>{{item.leido_hora?item.leido_hora.substr(0,5):''}}</td>
                    <td class="button-actions">
                        <button mat-icon-button color="primary" (click)="edit($index, item)" [disabled]="deshabilitado" class="p-1">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn" (click)="delete($index, item)" [disabled]="deshabilitado" class="p-1">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </tr>
            }
        </table>
    </div>
    <form [formGroup]="formEnvioAB" (submit)="save()">
        <div class="flex p-5 pb-0 justify-start items-top">
            <mat-form-field class="w-1/4 mr-5">
                <mat-label>Forma de Envío</mat-label>
                <mat-select formControlName="tipo">
                    @for (item of catEnvioAB; track item) {
                        @if(item.activo && (!item.use || item.id == editFormaEnvio?.tipo)) {
                            <mat-option [value]="item.id">{{item.descripcion}}</mat-option>
                        }
                    }
                    <mat-option value="otro">Otro</mat-option>
                </mat-select>
                @if(formEnvioAB.controls["tipo"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            @if(formEnvioAB.get('tipo')?.value == 'otro') {
                <mat-form-field class="w-1/4 mr-5">
                    <mat-label>Otra forma de envío</mat-label>
                    <input type="text" matInput formControlName="tipo_descripcion" #tipo_descripcion maxlength="100">
                    <mat-hint align="end">{{tipo_descripcion.value.length}} / 100</mat-hint>
                    @if(formEnvioAB.controls["tipo_descripcion"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
            }
            @if(formEnvioAB.get('tipo')?.value == '-LLe6-mlTJn4XMIQhm9Z') {
                <mat-form-field class="w-1/4 mr-5">
                    <mat-label>Reunión</mat-label>
                    <input type="text" matInput formControlName="reunion_descripcion" #reunion_descripcion maxlength="50">
                    <mat-hint align="end">{{reunion_descripcion.value.length}} / 50</mat-hint>
                    @if(formEnvioAB.controls["reunion_descripcion"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
            }
            <mat-form-field class="w-1/4 mr-5">
                <mat-label>Enviado por</mat-label>
                <mat-select formControlName="enviado">
                    @for (item of catUsuarios; track item) {
                        <mat-option [value]="item.id">{{item.nombre}}</mat-option>
                    }
                </mat-select>
                @if(formEnvioAB.controls["enviado"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="w-1/4 mr-5">
                <mat-label>Fecha Envío</mat-label>
                <input matInput [matDatepicker]="picker" [max]="today" formControlName="fecha">
                <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                @if(formEnvioAB.controls["fecha"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>       
                }
            </mat-form-field>
            <mat-slide-toggle color="primary" class="w-auto mt-5 mr-5" formControlName="leido">Leído</mat-slide-toggle>
        </div>
        <div class="flex p-5 pb-0 justify-start">
            @if(formEnvioAB.get('leido')?.value) {
                <mat-form-field  class="w-1/4 mr-5">
                    <mat-label>Fecha Leído</mat-label>
                    <input matInput [matDatepicker]="picker2" [min]="formEnvioAB.value.fecha" [max]="today" formControlName="leido_fecha">
                    <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                    <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                    @if(formEnvioAB.controls["leido_fecha"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>       
                    }
                </mat-form-field>

                <mat-form-field class="w-1/4 mr-5">
                    <mat-label>Hora Leído</mat-label>
                    <input matInput type="time" formControlName="leido_hora" step="60">
                    @if(formEnvioAB.controls["leido_hora"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>       
                    }
                </mat-form-field>
            }
        </div>
        <div class="flex p-5 pb-0 justify-start items-center">
            @if(editFormaEnvio == null){
                <button mat-raised-button color="primary" type="submit" [disabled]="formEnvioAB.invalid || deshabilitado">AGREGAR</button>
            } @else {
                <button mat-stroked-button color="primary" type="button" (click)="resetForm()" class="mr-5">CANCELAR</button>
                <button mat-flat-button color="primary" type="submit" [disabled]="formEnvioAB.invalid">GUARDAR</button>
            }
        </div>
    </form>
</div>